<template>
  <v-card :loading="loading">

    
    <v-alert v-if="erros" type="error">
      {{ erros }}
    </v-alert>
    
      <v-container>
        <v-form
          ref="formAcionado"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-select
                v-model="$v.formAcionado.tipoacionado_id.$model"
                :items="tipoAcionados"
                :error-messages="validacaoForm($v.formAcionado.tipoacionado_id, 'Tipo de Acionado')"
                label="Tipo de Acionado"
                :disabled="disableTipoAcionado"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                :masked="true"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="$v.formAcionado.pessoa.nr_cpfcnpj.$model"
                :error-messages="validacaoForm($v.formAcionado.pessoa.nr_cpfcnpj, 'CPF')"
                :label="!$v.formAcionado.pessoa.nr_cpfcnpj.$model.length ? 'Cpf/Cnpj' : $v.formAcionado.pessoa.nr_cpfcnpj.$model.length < 15 ? 'Cpf' : 'Cnpj'"
                @change="buscaAcionadoPorCpfCnpj($v.formAcionado.pessoa.nr_cpfcnpj.$model)"
                :loading="loadingBuscarCpfCnpj"
                :disabled="formAcionado.id > 0"
              ></v-text-field>

            </v-col>
            <v-col
              cols="12"
              md="8"
            >
              <v-text-field
                v-model.lazy="$v.formAcionado.pessoa.nm_pessoa.$model" 
                :error-messages="validacaoForm($v.formAcionado.pessoa.nm_pessoa, 'Nome')"
                :counter="60"
                label="Nome"
                v-remove-acentos="'uppercase'"
                autocomplete="nope"
                v-on:change.native="validaAlteracao($event)"
              >
              </v-text-field>
            </v-col> 
          </v-row>
          <div v-show="isPessoaFisica" v-if="formAcionado.pessoa">
            <pessoa-fisica ref="formPessoaFisica" :pessoaFisica="formAcionado.pessoa.pessoa_fisica"></pessoa-fisica>
          </div>
          <div v-show="!isPessoaFisica">
            <pessoa-juridica ref="formPessoaJuridica" :pessoaJuridica="formAcionado.pessoa.pessoa_juridica" :isPessoaFisica="isPessoaFisica"></pessoa-juridica>
          </div>
          <v-tabs
            v-model="tab"
            background-color="success"
            dark
          >
            <v-tab>Endereço</v-tab>
            <v-tab>Telefone</v-tab>
            <v-tab>E-mail</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            
            <v-tab-item>
              <endereco-pessoa ref="formEnderecos" :enderecos="formAcionado.pessoa.enderecos  || []"></endereco-pessoa>
            </v-tab-item>
            <v-tab-item>
              <telefone-pessoa ref="formTelefones" :telefones="formAcionado.pessoa.telefones || []"></telefone-pessoa>
            </v-tab-item>
            <v-tab-item>
              <email-pessoa ref="formEmails" :emails="formAcionado.pessoa.emails  || []"></email-pessoa>
            </v-tab-item>
          </v-tabs-items>         
        </v-form>
      </v-container>

  </v-card>
</template>

<script>

import {required, requiredIf, email, minLength, maxLength, numeric, helpers} from 'vuelidate/lib/validators'
import validacaoForm from '@/mixins/validacaoForm'
import utils from '@/mixins/utils'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
const { cpf, cnpj } = require('cpf-cnpj-validator');
const validaCpfCnpj = (num) => {
  if (!num) return true
  num = num.replace(/[^a-zA-Z0-9]/g, '')
  if (num.length == 11) {
    if (cpf.isValid(num)) { return true}
  } else if (num.length == 14) {
    if (cnpj.isValid(num)) { return true }
  }
  return false
}

export default {
  name: 'CadastroAcionado',
  props: ['tipoacionado_id'],
  mixins:[validacaoForm, utils],
  components:{
    EnderecoPessoa: () => import('@/views/Comum/EnderecoPessoa.vue'),
    TelefonePessoa: () => import('@/views/Comum/TelefonePessoa.vue'),
    EmailPessoa: () => import('@/views/Comum/EmailPessoa.vue'),
    PessoaFisica: () => import('@/views/Comum/PessoaFisica.vue'),
    PessoaJuridica: () => import('@/views/Comum/PessoaJuridica.vue'),
  },
  data () {
    return {
      minHeightTab: 250,
      loadingBuscarCpfCnpj: false,
      tab: null,
      tabPrincipal: null,
      loading: false,
      isPessoaFisica: true,
      tipoAcionados: [],
      formAcionado: {},
      disableTipoAcionado: false,
    }
  },
  validations: {
    formAcionado: {
      tipoacionado_id: {required, errors:[]},
      pessoa: {
        nm_pessoa: {required, minLength: minLength(3), maxLength: maxLength(60), errors: [] },
        nr_cpfcnpj: {required, validaCpfCnpj, errors: []},
      }
    },
  },
  mounted(){
  },
  async created() {
    this.resetErros()
    this.sincronizarAcionado(this.acionadoSelecionado)
    this.carregaTiposAcionado()
    this.actloadDropDownMunicipio()
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      actLoadDropDownTipoAcionado: 'tipoacionado/LOAD_DROPDOWN',
      actStoreAcionado: 'acionado/STORE_ACIONADO',
      actGetCpfCnpj: 'acionado/GET_CPFCNPJ',
      actloadDropDownMunicipio: 'municipio/LOAD_DROPDOWN',
    }),
    ...mapGetters({
      getErros: 'acionado/GET_ERROS',
    }),
    ...mapMutations({
      acionadoselected: 'acionado/ACIONADO_SELECTED',
      resetErros: 'acionado/ERASE_ERROS',
    }),
    async buscaAcionadoPorCpfCnpj(cpfcnpj) {
      cpfcnpj.length <= 14 ? this.isPessoaFisica = true : this.isPessoaFisica = false
      if (cpfcnpj.length === 14 || cpfcnpj.length === 18) {
        this.loadingBuscarCpfCnpj = true
        let send = cpfcnpj.replace(/[^a-zA-Z0-9]/g, '');
        await this.actGetCpfCnpj(send)
        this.loadingBuscarCpfCnpj = false
      }
    },
    sincronizarAcionado (acionado) {
      //this.formAcionado = Object.assign({}, acionado)
      this.formAcionado = JSON.parse(JSON.stringify(acionado))
      if (this.formAcionado.pessoa && this.formAcionado.pessoa.tp_pessoa && this.formAcionado.pessoa.tp_pessoa === '') this.formAcionado.pessoa.tp_pessoa = 'Fisica'
      this.isPessoaFisica = this.formAcionado.pessoa.tp_pessoa === 'Fisica' ? true : false
      if (this.tipoacionado_id > 0 && !this.formAcionado.tipoacionado_id) {
        this.formAcionado.tipoacionado_id = this.tipoacionado_id
        this.disableTipoAcionado = true
      } 
    },
    converteDataToApi(data) {
      if (!data) return null
      let dtTeste = String(data)
      dtTeste = dtTeste.replace(/[^ -zA-Z0-9]/g, '');
      if (data.length === 10) {
        let dataformatado =  this.$moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD')
        var dateObj = new Date(dataformatado);
        var momentObj = this.$moment(dateObj);
        data = dataformatado
      }
      return data 
    },
    PessoaEhFisica () {
      if (this.isPessoaFisica) return true
      return false
    },
    /*tipoPessoa () {
      if (this.formAcionado.pessoa.tp_pessoa === 'Fisica') {
        this.ehPessoaFisica = true
      } else {
        this.ehPessoaFisica = false
      }
    },*/
    async selecionar() {
      try {
        if (!this.formAcionado.id) return { status: false }  
        return {status: true, value: this.formAcionado.id, text: this.formAcionado.pessoa.nm_pessoa}
      } catch (error) {
      }      
    },
    async gravarComRetorno() {
      try {
        if (!await this.gravar()) return {status: false}
        let ret = { status: true, value: this.formAcionado.id, text: this.formAcionado.pessoa.nm_pessoa }
        return ret
      } catch (error) {
        reject(error)
      }
    },
    validaAlteracao(event) {
      this.$nextTick(() => {
        let nomeForm = this.formAcionado.pessoa.nm_pessoa 
        let nomeStore = this.acionadoSelecionado.pessoa.nm_pessoa
        if (nomeStore != "" && nomeStore !== nomeForm) {
          this.$dialog.confirm("Você tem certeza que deseja alterar o nome do Acionado?", {loader: true, okText: 'Sim', cancelText: 'Não',})
          .then(dialog => {
            this.acionadoSelecionado.pessoa.nm_pessoa = this.formAcionado.pessoa.nm_pessoa
            dialog.close();
          })
          .catch((e) => {
            this.formAcionado.pessoa.nm_pessoa = this.acionadoSelecionado.pessoa.nm_pessoa
          })
        }
      })
      event.preventDefault()
    },
    async gravar () {
      this.loading = "success"
      if (!(await this.validaForm())) {
        this.loading = false
        return false
      }
      if (this.$refs.formPessoaFisica) {
        if (!await this.$refs.formPessoaFisica.validaForm()) {
          this.loading = false
          return false
        }
        let objPessoaFisica = await this.$refs.formPessoaFisica.gravar()
        this.formAcionado.pessoa.pessoa_fisica = objPessoaFisica
      }
      if (this.$refs.formPessoaJuridica) {
        if (!await this.$refs.formPessoaJuridica.validaForm()) {
          this.loading = false
          return false
        }
        let objPessoaJuridica = await this.$refs.formPessoaJuridica.gravar()
        this.formAcionado.pessoa.pessoa_juridica = objPessoaJuridica
      }
      if (this.$refs.formEnderecos) {
        if (!await this.$refs.formEnderecos.validaForm()) {
          this.loading = false
          return false
        }
        let objEndereco = await this.$refs.formEnderecos.gravar()
        this.formAcionado.pessoa.enderecos = objEndereco
      }
      if (this.$refs.formTelefones) {
        if (!await this.$refs.formTelefones.validaForm()) {
          this.loading = false
          return false
        }
        let objTelefone = await this.$refs.formTelefones.gravar()
        this.formAcionado.pessoa.telefones = objTelefone
      }
      if (this.$refs.formEmails) {
        if (!await this.$refs.formEmails.validaForm()) {
          this.loading = false
          return false
        }
        let objEmail = await this.$refs.formEmails.gravar()
        this.formAcionado.pessoa.emails = objEmail
      }
      //return
      if (!(await this.store())) {
        this.$toaster.error('Erro ao gravar!');
        return false
      }
      this.$toaster.success('Gravação efetuada com sucesso!');
      return true
      //this.$emit('close')
    },
    async validaForm () {
      this.$v.formAcionado.$touch();
      if (!this.$v.formAcionado.$invalid) {
        return true
      } else if (this.$v.formAcionado.$anyError) {
        return false
      }
    },
    async store () {
      try {
        var acionado = JSON.parse(JSON.stringify(this.formAcionado))
        if (acionado.pessoa.pessoa_fisica && acionado.pessoa.pessoa_fisica.dt_nascimento) {
          var dataNascto = acionado.pessoa.pessoa_fisica.dt_nascimento
          try {
            dataNascto = this.converteDataToApi(dataNascto)
          } catch(e) {
            this.commitErro({erros: "Erro ao converter data de nascimento em 'store'" })
            this.loading = false
            return false
          }
          acionado.pessoa.pessoa_fisica.dt_nascimento = dataNascto
        }

        var sucess = false
        acionado.pessoa.nr_cpfcnpj = acionado.pessoa.nr_cpfcnpj.replace(/[^a-zA-Z0-9]/g, '')
        acionado.pessoa.tp_pessoa = 'Fisica'
        if (acionado.pessoa.nr_cpfcnpj.length > 11) acionado.pessoa.tp_pessoa = 'Juridica'

        try {
          await this.actStoreAcionado(acionado)
        } catch (e) {
          console.log(e)
          this.commitErro({erros: "Erro ao enviar dados para Api 'store'" })
          return false
        }

        if (!this.erros) sucess = true        
        return sucess

      } catch(e) {
        this.commitErro({erros: "Erro não tratado em 'store'" })
        console.log(e)
        return false
      } finally {
        this.loading = false
      }
    },
    async carregaTiposAcionado() {
      this.actLoadDropDownTipoAcionado()
    },
  },
  watch: {
    acionadoSelecionado(novo, antigo) {
      this.sincronizarAcionado(novo)
    },
    erros(novo, antigo) {
      return novo
    },
    dropdownTipoAcionado(newValue, oldValue) {
      this.tipoAcionados = newValue
    },
    isPessoaFisica (newValue, oldValue) {
      if (newValue !== oldValue) {
       // return newValue
      }
    }
  },
  computed: {
    ...mapState('acionado', [
      'acionadoSelecionado',
      'erros',
    ]),
    ...mapState('tipoacionado', [
      'dropdownTipoAcionado'
    ]),
  },
}
</script>

<style scoped>
  .v-btn {
    padding: 0 !important;
  }
  
</style>


// WEBPACK FOOTER //
// src/views/Acionado/CadastroAcionado.vue